module.exports = __webpack_public_path__ + "img/akfel-wgc-paris-multitouch-application-05.be98cbb8.jpg";